<template>
    <template v-if="labelHasInfoAction">
        <a class="hcl-form-element-label-action" @click.prevent="onLabelInfoActionClick">
            <template v-if="labelHasInfoTooltip">
                <i :class="labelInfoIcon" data-toggle="tooltip" data-placement="top" :title="props.labelInfo.tooltip"></i>
            </template>
            <template v-else>
                <i :class="labelInfoIcon"></i>
            </template>
        </a>
    </template>
    <template v-else>
        <template v-if="labelHasInfoTooltip">
            <i :class="labelInfoIcon" data-toggle="tooltip" data-placement="top" :title="props.labelInfo.tooltip"></i>
        </template>
        <template v-else>
            <i :class="labelInfoIcon"></i>
        </template>
    </template>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

import { DefintionFormLabelInfo } from '@/components/types'

interface Props {
    labelInfo: DefintionFormLabelInfo
}

const props = withDefaults(defineProps<Props>(), {
    labelInfo: undefined
})

const labelInfoIcon = computed(() => {
    if ((props.labelInfo.icon ?? undefined) !== undefined)
        return props.labelInfo.icon

    return 'eii--fa6-solid--circle-info'
})

const labelHasInfoAction = computed(() => {
    return (props.labelInfo.action ?? undefined) !== undefined
})

const labelHasInfoTooltip = computed(() => {
    return (props.labelInfo.tooltip ?? undefined) !== undefined
})

const windowRef = ref(window as Window)

const onLabelInfoActionClick = () => {

    if (props.labelInfo.type !== 'link') return

    if (props.labelInfo.action === 'open') {
        windowRef.value.open(props.labelInfo.url ?? '', '_link')
    }

    if (props.labelInfo.action === 'popup') {
        const pHeight = windowRef.value.innerHeight - 10
        const pWidth = Math.ceil((windowRef.value.innerWidth - 10) / 1.5)

        windowRef.value.open(
            props.labelInfo.url ?? '',
            'popUpWindow',
            `height=${pHeight}, width=${pWidth}, left=10, top=10, resizable=yes, scrollbars=yes`
        )
    }

    if (props.labelInfo.action === 'replace') {
        windowRef.value.location = props.labelInfo.url ?? ''
    }
}
</script>

<style lang="scss" scoped>
.hcl-form-element-label-action {
    cursor: pointer;
}
</style>